import { IconWrapper } from '../runtime';
export default IconWrapper('wpp_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#F5670F"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#DF4D00"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#FF8940"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.5 2.5V11H6V8H9.25C10.7688 8 12 6.76878 12 5.25C12 3.73122 10.7688 2.5 9.25 2.5H4.5ZM6 6.5H9.25C9.94036 6.5 10.5 5.94036 10.5 5.25C10.5 4.55964 9.94036 4 9.25 4H6V6.5Z",
      "fill": "white"
    }
  })]);
});